<template>
  <div class="container" id="projects">
    <div class="row">
      <div class="col-12">
        <div class="project-text">
          <div class="mb-3">
            <h3 class="text-center">My Recent Works</h3>
          </div>
          <!-- <div class="d-flex my-5">
            <div>
              <p @click="changeShow('all')" :class="['text-black-50 me-5', { 'active-text': toShow == 'all' }]">All</p>
            </div>
            <div>
              <p @click="changeShow('web-design')" :class="['text-black-50 me-5', { 'active-text': toShow == 'web-design' }]">Web Designs</p>
            </div>
            <div>
              <p @click="changeShow('web-app')" :class="['text-black-50 me-5', { 'active-text': toShow == 'web-app' }]">Web Apps</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row gy-3">
      <div class="col-12 col-md-4" v-for="project in filteredProjects" :key="project.id">
        <div class="card blur shadow" :id="'card' + project.id">
          <div class="card-body">
            <div class="mb-3 p-2">
              <carousel :items-to-show="1">
                <slide v-for="(cover, ind) in project.cover" :key="ind">
                  <div class="carousel__item"><img :src="cover" class="w-100 service-card-img rounded" alt="" /></div>
                </slide>

                <template #addons>
                  <navigation />
                  <pagination />
                </template>
              </carousel>
            </div>
            <h5 class="card-title fw-bold">{{ project.title }}</h5>
            <p class="card-text my-3">{{ project.description }}</p>
            <a :href="project.link" v-if="project.link" class="btn btn-primary">
              Visit
              <i class="bi bi-box-arrow-right ms-1"></i>
            </a>
            <a :href="project.code" v-if="project.code" class="btn btn-outline-primary ms-3">
              Code
              <i class="bi bi-github ms-1"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

import { computed, ref } from "@vue/runtime-core";
export default {
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  setup() {
    let projects = [
      { id: 1, cover: [require("../../src/assets/photo/projects/pos/pos.png"), require("../../src/assets/photo/projects/pos/pos-dashboard.png"), require("../../src/assets/photo/projects/pos/pos-daily.png"), require("../../src/assets/photo/projects/pos/pos-monthly.png"), require("../../src/assets/photo/projects/pos/pos-item.png")], title: "POS with Laravel + Vue (Inertia)", description: "Pos system using Laravel, Vue as front-end with IneritaJs. Provide with admin dashboard and daily-reports and monthly-reports features, export reports to pdf and visual analysis with Chart.js", link: null, code: "https://github.com/kimmichDev/pos-inerita", category: "web-app", techs: ["../assets/photo/path/bootstrap-5.svg", "../assets/photo/path/javascript.svg", "../assets/photo/path/laravel.svg", "../assets/photo/path/mysql.svg"] },
      { id: 2, cover: [require("../../src/assets/photo/projects/contact/contact-app.png"), require("../../src/assets/photo/projects/contact/contact-app-send.png"), require("../../src/assets/photo/projects/contact/contact-app-restore.png"), require("../../src/assets/photo/projects/contact/contact-app-permanent.png"), require("../../src/assets/photo/projects/contact/contact-app-noti.png")], title: "Contact App", description: "Laravel Contact app with mobile-first design. User can share contact to another user and recipient can deny or accept, soft delete and restore feature , and bulk function for actions.", link: null, code: "https://github.com/kimmichDev/laravel_contact_app", category: "web-app", techs: ["../assets/photo/path/bootstrap-5.svg", "../assets/photo/path/javascript.svg", "../assets/photo/path/laravel.svg", "../assets/photo/path/mysql.svg"] },
      { id: 3, cover: [require("../../src/assets/photo/projects/greenPindaya.jpg")], title: "Website for local company", description: "Dynamic content web for company named GreenPindaya, with admin panel, webmails, develop web design to suit client's need.", link: "https://greenpindaya.com", code: null, category: "web-app", techs: ["../assets/photo/path/bootstrap-5.svg", "../assets/photo/path/javascript.svg", "../assets/photo/path/laravel.svg", "../assets/photo/path/mysql.svg"] },
      { id: 4, cover: [require("../../src/assets/photo/projects/chat-room.jpg")], title: "Chat Room", description: "Chat room app with firebase's auth and real time database system. In this app user can create account and send messages in chat room.", link: "https://chat-room-9112f.web.app/", code: "https://github.com/kimmichDev/vue-chat-room", category: "web-app", techs: ["../assets/photo/path/bootstrap-5.svg", "../assets/photo/path/javascript.svg", "../assets/photo/path/vue.svg", "../assets/photo/path/firebase.svg"] },
      { id: 5, cover: [require("../../src/assets/photo/projects/furniture.jpg")], title: "Furniture website concept", description: "Developed with only html,css,js and some cool libraries. Try to focus on clean and neat approach when building", link: "https://designpj.netlify.app/", code: "https://designpj.netlify.app/", category: "web-design", techs: ["../assets/photo/path/bootstrap-5.svg", "../assets/photo/path/javascript.svg", "../assets/photo/path/html.svg", "../assets/photo/path/css-3.svg"] },
      { id: 6, cover: [require("../../src/assets/photo/projects/invoice.jpg")], title: "Invoice Maker", description: "I developed this web app through learning Vue 3 and firebase as database. In this app, after creating invoice , you'll get KEY and find the old invoices via this KEY anytime you want.", link: "https://vue-invoice-maker.vercel.app/", code: "https://github.com/kimmichDev/vue-invoice-maker", category: "web-app", techs: ["../assets/photo/path/bootstrap-5.svg", "../assets/photo/path/javascript.svg", "../assets/photo/path/firebase.svg", "../assets/photo/path/vue.svg"] },
    ];
    let toShow = ref("all");

    let filteredProjects = computed(() => {
      if (toShow.value == "web-app") {
        return projects.filter((p) => p.category == "web-app");
      } else if (toShow.value == "web-design") {
        return projects.filter((p) => p.category == "web-design");
      } else {
        return projects;
      }
    });

    let changeShow = (showValue) => {
      toShow.value = showValue;
      console.log(toShow.value);
    };
    return { projects, filteredProjects, toShow, changeShow };
  },
};
</script>

<style scoped>
.carousel__prev--in-active,
.carousel__next--in-active {
  display: none;
}
.active-text {
  color: black !important;
}
.d-flex p:hover {
  cursor: pointer;
}
.active-text::after {
  width: 5px;
  height: 5px;
  display: block;
  content: "";
  position: absolute;
  border-radius: 50%;
  background: #000;
}
</style>
